// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventReasonsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChangeEventReasonsQuery = { __typename?: 'Query', changeEventReasons: Array<{ __typename?: 'ChangeEventReason', id: string, name: string, code: string, archived: boolean, isEpo: boolean }> };

export type ChangeEventReasonsDataFragment = { __typename?: 'ChangeEventReason', id: string, name: string, code: string, archived: boolean, isEpo: boolean };

export const ChangeEventReasonsDataFragmentDoc = gql`
    fragment ChangeEventReasonsData on ChangeEventReason {
  id
  name
  code
  archived
  isEpo
}
    `;
export const ChangeEventReasonsDocument = gql`
    query ChangeEventReasons {
  changeEventReasons {
    ...ChangeEventReasonsData
  }
}
    ${ChangeEventReasonsDataFragmentDoc}`;

/**
 * __useChangeEventReasonsQuery__
 *
 * To run a query within a React component, call `useChangeEventReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangeEventReasonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>(ChangeEventReasonsDocument, options);
      }
export function useChangeEventReasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>(ChangeEventReasonsDocument, options);
        }
// @ts-ignore
export function useChangeEventReasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>;
export function useChangeEventReasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventReasonsQuery | undefined, ChangeEventReasonsQueryVariables>;
export function useChangeEventReasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>(ChangeEventReasonsDocument, options);
        }
export type ChangeEventReasonsQueryHookResult = ReturnType<typeof useChangeEventReasonsQuery>;
export type ChangeEventReasonsLazyQueryHookResult = ReturnType<typeof useChangeEventReasonsLazyQuery>;
export type ChangeEventReasonsSuspenseQueryHookResult = ReturnType<typeof useChangeEventReasonsSuspenseQuery>;
export type ChangeEventReasonsQueryResult = ApolloReactCommon.QueryResult<ChangeEventReasonsQuery, ChangeEventReasonsQueryVariables>;